import {getDocument} from './utils';

function copyToClipboardFallback(value: string) {
  const targetDocument = getDocument();
  const targetBody = targetDocument.body;

  if (!targetBody) {
    return;
  }

  const el = targetDocument.createElement('textarea');
  el.value = value;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  el.style.pointerEvents = 'none';
  el.style.left = '-9999px';
  targetBody.appendChild(el);
  el.focus();
  el.select();
  targetDocument.execCommand('copy');
  targetBody.removeChild(el);
}

export function copyToClipboard(value: string | number) {
  const text = typeof value === 'number' ? value.toString() : value;
  const targetDocument = getDocument();
  const clipboard =
    targetDocument.defaultView?.navigator?.clipboard ?? globalThis.navigator?.clipboard;

  if (!clipboard?.writeText) {
    copyToClipboardFallback(text);
    return;
  }

  void clipboard.writeText(text).catch(() => {
    copyToClipboardFallback(text);
  });
}
